import React, { useState, useEffect, useRef, useCallback } from "react";
import { Modal } from "bootstrap";
import { GetOFDByDatesForSchedule } from "../api/ofd";
import { GetByNotApproved, Approve, GetById } from "../api/approved_dep";

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getNextShiftId(shifts) {
  if (!shifts?.length) return 1;
  return Math.max(...shifts.map((s) => s.id || 0)) + 1;
}

function isSameShift(a, b) {
  if (!a?.id || !b?.id) return false;
  return (
    a.id === b.id &&
    a.date === b.date &&
    a.station_name === b.station_name &&
    a.start === b.start
  );
}

function getShiftKey(ts) {
  if (!ts?.id) return null;
  return `${ts.id}|${ts.date}|${ts.station_name}|${ts.start}`;
}

function getNextWeekRange(baseDate = new Date()) {
  const today = new Date(baseDate);
  today.setHours(0, 0, 0, 0);
  const day = today.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;
  const currentMonday = new Date(today);
  currentMonday.setDate(today.getDate() + diffToMonday);

  const nextMonday = new Date(currentMonday);
  nextMonday.setDate(currentMonday.getDate() + 7);

  const nextSunday = new Date(nextMonday);
  nextSunday.setDate(nextMonday.getDate() + 6);

  return {
    startDate: formatDate(nextMonday),
    endDate: formatDate(nextSunday),
  };
}

const AutoDep = ({ token, accessLevel }) => {
  const [startDate, setStartDate] = useState(() => getNextWeekRange().startDate);
  const [endDate, setEndDate] = useState(() => getNextWeekRange().endDate);
  const [tables, setTables] = useState([]);
  const [selectedType, setSelectedType] = useState("DT");
  const [doneTemplateShifts, setDoneTemplateShifts] = useState([]);
  const [lastId, setLastId] = useState(1);
  const [receipts, setReceipts] = useState({});
  const [selectedDate, setSelectedDate] = useState();
  const [startNewTS, setStartNewTS] = useState(22);
  const [endNewTS, setEndNewTS] = useState(6);
  const [selectedTS, setSelectedTS] = useState({ start: 0, hours: 0 });
  const [startPlusEditTS, setStartPlusEditTS] = useState(0);
  const [endPlusEditTS, setEndPlusEditTS] = useState(0);
  const [TSHours, setTSHours] = useState(0);
  const [modalMessageCreate, setModalMessageCreate] = useState("");
  const [modalMessageEdit, setModalMessageEdit] = useState("");
  const [divideSelectedTS, setDivideSelectedTS] = useState(0);
  const [firstDivededTS, setFirstDiveidedTS] = useState({});
  const [secondDivededTS, setSecondDiveidedTS] = useState({});
  const [disabledApproveBtn, setDisabledApproveBtn] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const [approves, setApproves] = useState([]);
  const [selectedApprove, setSelectedApprove] = useState({});
  const [showLoadReceiptsBtn, setShowLoadReceiptsBtn] = useState(false);

  const [comment, setComment] = useState("");
  const [status, setStatus] = useState(1);
  const [approveMessage, setApproveMessage] = useState("");
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [saveDraftMessage, setSaveDraftMessage] = useState("");
  const [editModalShift, setEditModalShift] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const dragRef = useRef(null);
  const suppressClickRef = useRef(false);
  const editShiftModalRef = useRef(null);

  const statuses = {
    1: "Не согласованно",
    2: "На доработке",
    3: "Согласованно",
  };

  function createTemplateShifts(data) {
    let id = 1;
    const hours = generateHours(startDate, DeltaDate(endDate, +1));
    const receiptsMap = {};
    data.map((hour) => {
      receiptsMap[new Date(hour.hour).getTime()] = hour;
    });

    const stations = selectDeploiment[selectedType];
    let templateShifts = [];
    stations.map((station) => {
      let templateShiftsStation = [];
      let currentShift = false;
      hours.map((hour) => {
        let receiptsNow = 0;
        if (receiptsMap[hour.getTime()]) {
          receiptsNow = receiptsMap[hour.getTime()].receipts;
        }

        if (!currentShift) {
          if (receiptsNow >= station.min_receipts) {
            let shiftEnd = hour.getHours() + 1;
            if (shiftEnd == 24) {
              shiftEnd = 0;
            }
            let shift = {
              station_name: station.name,
              start: hour.getHours(),
              end: shiftEnd,
              hours: 1,
              date: hoursInDate(hour),
              group_station_name: station.group_station_name,
              id: id,
            };
            id += 1;
            templateShiftsStation.push(shift);
            currentShift = shift;
          }
        } else {
          if (currentShift && hour.getHours() === currentShift.end) {
            if (receiptsNow >= station.min_receipts) {
              if (currentShift.end + 1 == 24) {
                currentShift.end = 0;
                currentShift.hours = 24 - currentShift.start;
              } else if (currentShift.start > currentShift.end) {
                currentShift.end = hour.getHours() + 1;
                currentShift.hours = 24 - currentShift.start + currentShift.end;
              } else {
                currentShift.end = hour.getHours() + 1;
                currentShift.hours = currentShift.end - currentShift.start;
              }

              if (currentShift.hours == 8) {
                currentShift = false;
              }
            }
          } else {
            currentShift = false;
          }
        }
      });
      templateShifts.push(...templateShiftsStation);
    });
    setReceipts(receiptsMap);
    setLastId(id);
    return [
      templateShifts.filter(
        (ts) => !(ts.start == 0 && ts.date == startDate) && ts.date <= endDate,
      ),
      receiptsMap,
    ];
  }

  async function loadOFD() {
    const data = await GetOFDByDatesForSchedule(
      token,
      startDate,
      DeltaDate(endDate, +1),
    );
    const [templateShifts, receiptsMap] = createTemplateShifts(data);
    setDoneTemplateShifts(templateShifts);
    refreshTables(templateShifts, startDate, endDate, receiptsMap);
  }

  function addTS() {
    setDoneTemplateShifts((prev) => {
      const newId = getNextShiftId(prev);
      const shifts = [
        ...prev,
        {
          station_name: "Ночник",
          start: parseInt(startNewTS, 10),
          end: parseInt(endNewTS, 10),
          hours: TSHours,
          date: selectedDate,
          group_station_name: "Ночь",
          manual: true,
          id: newId,
        },
      ];
      setLastId(newId + 1);
      refreshTables(shifts);
      return shifts;
    });
    setModalMessageCreate(<p style={{ color: "green" }}>Создано!</p>);
  }

  function validateShiftPlusHours(plus_before, plus_after, shift) {
    if (Number.isNaN(plus_before) || Number.isNaN(plus_after)) {
      return { valid: false, message: "Введите корректное число" };
    }
    if (plus_before < 0 || plus_after < 0) {
      return { valid: false, message: "Отрицательные значения!" };
    }
    if (shift.start - plus_before < 0) {
      return { valid: false, message: "Много взял сначала!" };
    }
    if (shift.hours + plus_before + plus_after >= 23) {
      return { valid: false, message: "Смена больше 23 часов!" };
    }
    return {
      valid: true,
      plus_before: parseInt(plus_before, 10),
      plus_after: parseInt(plus_after, 10),
    };
  }

  function commitShiftPlusHours(plusBeforeRaw, plusAfterRaw) {
    if (!selectedTS.id) return false;

    const plus_before = parseFloat(plusBeforeRaw);
    const plus_after = parseFloat(plusAfterRaw);
    const validation = validateShiftPlusHours(plus_before, plus_after, selectedTS);

    if (!validation.valid) {
      setModalMessageEdit(
        <p style={{ color: "red" }}>{validation.message}</p>,
      );
      setStartPlusEditTS(selectedTS.plus_before || 0);
      setEndPlusEditTS(selectedTS.plus_after || 0);
      return false;
    }

    const templateShifts = doneTemplateShifts.map((ts) => {
      if (isSameShift(ts, selectedTS)) {
        return {
          ...ts,
          plus_before: validation.plus_before,
          plus_after: validation.plus_after,
        };
      }
      return ts;
    });
    const updatedSelected = templateShifts.find((ts) => isSameShift(ts, selectedTS));
    if (!updatedSelected) return false;

    setDoneTemplateShifts(templateShifts);
    refreshTables(templateShifts);
    setSelectedTS(updatedSelected);
    setEditModalShift(updatedSelected);
    setStartPlusEditTS(updatedSelected.plus_before || 0);
    setEndPlusEditTS(updatedSelected.plus_after || 0);
    setModalMessageEdit("");
    return true;
  }

  function handleStartPlusInputChange(raw) {
    setStartPlusEditTS(raw);
    if (raw === "" || Number.isNaN(parseFloat(raw))) return;
    commitShiftPlusHours(raw, endPlusEditTS);
  }

  function handleEndPlusInputChange(raw) {
    setEndPlusEditTS(raw);
    if (raw === "" || Number.isNaN(parseFloat(raw))) return;
    commitShiftPlusHours(startPlusEditTS, raw);
  }

  function adjustSelectedShift(edge, delta) {
    if (!selectedTS.id) return;
    const plus_before =
      edge === "start"
        ? Math.max(0, (selectedTS.plus_before || 0) + delta)
        : selectedTS.plus_before || 0;
    const plus_after =
      edge === "end"
        ? Math.max(0, (selectedTS.plus_after || 0) + delta)
        : selectedTS.plus_after || 0;
    commitShiftPlusHours(plus_before, plus_after);
  }

  function closeEditShiftModal() {
    const modalEl = editShiftModalRef.current;
    if (modalEl) {
      Modal.getInstance(modalEl)?.hide();
    }
    setShowEditModal(false);
    setEditModalShift(null);
  }

  const openShiftEditModal = useCallback((ts) => {
    if (!ts?.id) return;
    if (
      suppressClickRef.current &&
      editModalShift &&
      isSameShift(ts, editModalShift)
    ) {
      return;
    }
    suppressClickRef.current = false;
    setModalMessageEdit("");
    setEditModalShift(ts);
    setSelectedTS(ts);
    setStartPlusEditTS(ts.plus_before || 0);
    setEndPlusEditTS(ts.plus_after || 0);
    setShowEditModal(true);
  }, [editModalShift]);

  function divideTS() {
    if (divideSelectedTS === 0) {
      setModalMessageEdit(<p style={{ color: "red" }}>Не выбрано деление</p>);
      return;
    }
    const templateShifts = doneTemplateShifts.map((ts) => {
      if (isSameShift(ts, selectedTS)) {
        return {
          ...ts,
          end: firstDivededTS.end,
          hours: firstDivededTS.hours,
          plus_after: 0,
        };
      }
      return ts;
    });

    const newId = getNextShiftId(templateShifts);
    const second = {
      ...selectedTS,
      start: secondDivededTS.start,
      hours: secondDivededTS.hours,
      id: newId,
      plus_before: 0,
    };

    const shifts = [...templateShifts, second];
    setDoneTemplateShifts(shifts);
    setLastId(newId + 1);
    refreshTables(shifts);
    const updatedFirst = templateShifts.find((ts) => isSameShift(ts, selectedTS));
    if (updatedFirst) {
      setSelectedTS(updatedFirst);
      setEditModalShift(updatedFirst);
    }
    closeEditShiftModal();
  }

  function selectShiftOnly(ts) {
    setSelectedTS(ts);
    setStartPlusEditTS(ts.plus_before || 0);
    setEndPlusEditTS(ts.plus_after || 0);
  }

  function dividingTS(value) {
    setDivideSelectedTS(value);
    setModalMessageEdit("");
    setFirstDiveidedTS({
      start: selectedTS.start,
      end: selectedTS.start + value,
      hours: value,
    });
    setSecondDiveidedTS({
      start: selectedTS.start + value,
      end: selectedTS.end,
      hours: getSumHoursBetween(selectedTS.start + value, selectedTS.end),
    });
  }

  function handleDragStart(event, shift, edge) {
    event.preventDefault();
    event.stopPropagation();
    const table = event.target.closest(".autodep-day-table");
    const hourCol = table?.querySelector(".autodep-hour-col");
    const hourWidth = hourCol?.offsetWidth || 36;
    dragRef.current = {
      baseShift: shift,
      edge,
      startX: event.clientX,
      hourWidth,
      initialPlusBefore: shift.plus_before || 0,
      initialPlusAfter: shift.plus_after || 0,
      lastAppliedDelta: 0,
    };
    setIsDragging(true);
    selectShiftOnly(shift);
  }

  const refreshTables = useCallback(
    (shifts, rangeStart = startDate, rangeEnd = endDate, receiptsData = receipts) => {
      setTables(
        renderAutoDepGrafic(
          { ts: shifts },
          rangeStart,
          DeltaDate(rangeEnd, +1),
          receiptsData,
          setSelectedDate,
          openShiftEditModal,
          handleDragStart,
          selectedTS,
        ),
      );
    },
    [startDate, endDate, receipts, getShiftKey(selectedTS), openShiftEditModal],
  );

  const applyDragDelta = useCallback(
    (deltaHours) => {
      if (!dragRef.current) return;
      const { edge, initialPlusBefore, initialPlusAfter, baseShift } =
        dragRef.current;

      setDoneTemplateShifts((prev) =>
        prev.map((ts) => {
          if (!isSameShift(ts, baseShift)) return ts;
          if (edge === "start") {
            const plus_before = Math.max(0, initialPlusBefore - deltaHours);
            if (baseShift.start - plus_before < 0) return ts;
            if (baseShift.hours + plus_before + initialPlusAfter >= 23) {
              return ts;
            }
            return { ...ts, plus_before };
          }
          const plus_after = Math.max(0, initialPlusAfter + deltaHours);
          if (baseShift.hours + initialPlusBefore + plus_after >= 23) {
            return ts;
          }
          return { ...ts, plus_after };
        }),
      );
    },
    [],
  );

  useEffect(() => {
    if (!isDragging) return undefined;

    const onMouseMove = (event) => {
      if (!dragRef.current) return;
      const { startX, hourWidth, lastAppliedDelta } = dragRef.current;
      const deltaHours = Math.round((event.clientX - startX) / hourWidth);
      if (deltaHours === lastAppliedDelta) return;
      dragRef.current.lastAppliedDelta = deltaHours;
      applyDragDelta(deltaHours);
    };

    const onMouseUp = () => {
      if (!dragRef.current) return;
      const { baseShift, lastAppliedDelta } = dragRef.current;
      if (lastAppliedDelta !== 0) {
        suppressClickRef.current = true;
        window.setTimeout(() => {
          suppressClickRef.current = false;
        }, 400);
      }
      dragRef.current = null;
      setIsDragging(false);
      setDoneTemplateShifts((prev) => {
        const updated = prev.find((ts) => isSameShift(ts, baseShift));
        if (updated) {
          setSelectedTS(updated);
          setEditModalShift(updated);
          setStartPlusEditTS(updated.plus_before || 0);
          setEndPlusEditTS(updated.plus_after || 0);
        }
        return prev;
      });
    };

    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [isDragging, applyDragDelta, refreshTables]);

  useEffect(() => {
    const start = parseInt(startNewTS, 10);
    const end = parseInt(endNewTS, 10);
    if (start > 24 || end > 24 || start < 0 || end < 0 || end == start) {
      setModalMessageCreate(<p style={{ color: "red" }}>Не корректные часы</p>);
      return;
    }
    setModalMessageCreate("");
    if (end > start) {
      setTSHours(end - start);
    } else {
      setTSHours(24 - start + end);
    }
  }, [startNewTS, endNewTS]);

  useEffect(() => {
    setStartPlusEditTS(selectedTS.plus_before || 0);
    setEndPlusEditTS(selectedTS.plus_after || 0);
    setFirstDiveidedTS({});
    setSecondDiveidedTS({});
    setDivideSelectedTS(0);
  }, [getShiftKey(selectedTS)]);

  useEffect(() => {
    if (!showEditModal || !editShiftModalRef.current) return undefined;

    const modalEl = editShiftModalRef.current;
    const modal = Modal.getOrCreateInstance(modalEl);
    modal.show();

    const onHidden = () => {
      setShowEditModal(false);
      setEditModalShift(null);
    };
    modalEl.addEventListener("hidden.bs.modal", onHidden);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", onHidden);
    };
  }, [showEditModal]);

  useEffect(() => {
    if (doneTemplateShifts?.length) {
      refreshTables(doneTemplateShifts);
    }
  }, [doneTemplateShifts, getShiftKey(selectedTS), refreshTables]);

  const fetchDataTY = async () => {
    const data = await GetByNotApproved(token);
    const approvesList = Array.isArray(data) ? data : [];

    if (accessLevel <= 12 && approvesList.length > 0) {
      const approve = approvesList[0];
      const templateShifts = approve.template_shifts || [];
      setStatus(approve.director_status);
      setComment(approve.director_comment);
      setStartDate(approve.start_date);
      setEndDate(approve.end_date);
      setSelectedApprove(approve);
      setDoneTemplateShifts(templateShifts);
      const data2 = await GetOFDByDatesForSchedule(
        token,
        approve.start_date,
        DeltaDate(approve.end_date, +1),
      );
      const [, receiptsMap] = createTemplateShifts(data2);
      setLastId(getNextShiftId(templateShifts));
      refreshTables(
        templateShifts,
        approve.start_date,
        approve.end_date,
        receiptsMap,
      );
    } else if (accessLevel <= 12) {
      setShowLoadReceiptsBtn(true);
    }
    setApproves(approvesList);
  };

  useEffect(() => {
    fetchDataTY();
  }, [token]);

  async function OpenApproveTS(id) {
    const data = await GetById(token, id);
    if (!data?.id) return;

    const approve = data;
    const templateShifts = approve.template_shifts || [];
    setStatus(approve.TY_status);
    setComment(approve.TY_comment);
    setSelectedApprove(approve);
    setDoneTemplateShifts(templateShifts);
    setStartDate(approve.start_date);
    setEndDate(approve.end_date);
    const data2 = await GetOFDByDatesForSchedule(
      token,
      approve.start_date,
      DeltaDate(approve.end_date, +1),
    );
    const [, receiptsMap] = createTemplateShifts(data2);
    setLastId(getNextShiftId(templateShifts));
    refreshTables(
      templateShifts,
      approve.start_date,
      approve.end_date,
      receiptsMap,
    );
    setApproves([]);
  }

  async function submitApprove(statusId, commentText) {
    if (selectedApprove?.TY_status == 3) {
      return {
        ok: false,
        message: "Деп уже в расписании! Редактирование невозможно!",
      };
    }

    const data = await Approve(
      token,
      startDate,
      endDate,
      statusId,
      commentText ?? "",
      doneTemplateShifts,
    );
    if (data.detail) {
      return { ok: false, message: data.detail };
    }

    setSelectedApprove(data);
    setStatus(statusId);
    setComment(commentText ?? "");
    return { ok: true, data };
  }

  async function saveDraft() {
    if (isSavingDraft || !(doneTemplateShifts?.length ?? 0)) return;

    setIsSavingDraft(true);
    setSaveDraftMessage("");
    setShowLoadReceiptsBtn(false);

    const result = await submitApprove(1, "еще делаю");
    if (!result.ok) {
      setSaveDraftMessage(<p style={{ color: "red" }}>{result.message}</p>);
    } else {
      setSaveDraftMessage(<p style={{ color: "green" }}>Сохранено!</p>);
    }
    setIsSavingDraft(false);
  }

  async function PostApprove() {
    setDisabledApproveBtn(true);
    setShowLoadReceiptsBtn(false);
    if (selectedApprove?.TY_status) {
      if (selectedApprove.TY_status == 3) {
        setApproveMessage(
          <p style={{ color: "red" }}>
            Деп уже в расписании! Редактирование невозможно!
          </p>,
        );
        setDisabledApproveBtn(false);
        return;
      }
    }

    const result = await submitApprove(status, comment);
    if (!result.ok) {
      setApproveMessage(<p style={{ color: "red" }}>{result.message}</p>);
    } else {
      setApproveMessage(<p style={{ color: "green" }}>Успех!</p>);
    }
    setDisabledApproveBtn(false);
  }

  async function backListDeps() {
    const data = await GetByNotApproved(token);
    setApproves(Array.isArray(data) ? data : []);
    setTables([]);
    setDoneTemplateShifts([]);
    setSelectedApprove({});
    setSelectedTS({ start: 0, hours: 0 });
  }

  function setNextWeekDates() {
    const range = getNextWeekRange();
    setStartDate(range.startDate);
    setEndDate(range.endDate);
  }

  const selectedShiftLabel = editModalShift?.id
    ? `${editModalShift.station_name} · ${editModalShift.date} · ${formatHourRange(editModalShift)}`
    : null;

  const toolbar = (
    <div className="autodep-toolbar card shadow-sm mb-3">
      <div className="card-body">
        <div className="row g-3 align-items-end">
          <div className="col-lg-4">
            <label className="form-label fw-semibold mb-1">Период</label>
            <div className="d-flex gap-2 align-items-center flex-wrap">
              <input
                type="date"
                className="form-control"
                onChange={(e) => setStartDate(e.target.value)}
                value={startDate}
              />
              <span className="text-muted">—</span>
              <input
                type="date"
                className="form-control"
                onChange={(e) => setEndDate(e.target.value)}
                value={endDate}
              />
            </div>
            <div className="form-text">{getMonthLabel(startDate, endDate)}</div>
          </div>
          <div className="col-lg-3">
            <label className="form-label fw-semibold mb-1">Тип ресторана</label>
            <select
              className="form-select"
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
            >
              <option value="IL">IL</option>
              <option value="FC">FC</option>
              <option value="DT">DT</option>
            </select>
          </div>
          <div className="col-lg-5 d-flex gap-2 flex-wrap align-items-center">
            <button type="button" className="btn btn-primary" onClick={loadOFD}>
              Загрузить чеки
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={setNextWeekDates}
            >
              Следующая неделя
            </button>
          </div>
        </div>
        <div className="autodep-hint mt-2">
          Клик по смене — редактирование и деление. Перетащите край смены,
          чтобы изменить длину.
        </div>
      </div>
    </div>
  );

  const showSaveFab = accessLevel <= 12 && (doneTemplateShifts?.length ?? 0) > 0;

  const saveDraftFab = showSaveFab && (
    <div className="autodep-save-fab">
      {saveDraftMessage && (
        <div className="autodep-save-fab-message">{saveDraftMessage}</div>
      )}
      <button
        type="button"
        className="btn btn-success shadow"
        onClick={saveDraft}
        disabled={isSavingDraft}
      >
        {isSavingDraft ? "Сохранение…" : "Сохранить"}
      </button>
    </div>
  );

  const approvalTable = (selectedApprove?.id || (doneTemplateShifts?.length ?? 0)) && (
    <div className="col-md-12 text-center">
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Должность</th>
            <th>Директор</th>
            <th>ТУ</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Статус</td>
            <td>{statuses[selectedApprove?.director_status || 1]}</td>
            <td>{statuses[selectedApprove?.TY_status || 1]}</td>
          </tr>
          <tr>
            <td>Комментарий</td>
            <td>{selectedApprove?.director_comment}</td>
            <td>{selectedApprove?.TY_comment}</td>
          </tr>
          <tr>
            <td>Сотрудник</td>
            <td>{selectedApprove?.director_surname_name}</td>
            <td>{selectedApprove?.TY_surname_name}</td>
          </tr>
          <tr>
            <td
              className="text-center autodep-clickable"
              colSpan={3}
              data-bs-toggle="modal"
              data-bs-target="#approvalModal"
            >
              Изменить
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  return (
    <div
      className={`container-fluid autodep-root${isDragging ? " autodep-dragging" : ""}${showSaveFab ? " autodep-has-save-fab" : ""}`}
    >
      <style>{AUTO_DEP_STYLES}</style>

      {accessLevel > 12 ? (
        <div className="row">
          <div className="col-md-6 offset-3 text-center">
            <h1>Несогласованные деплойменты</h1>
            {selectedApprove?.id && (
              <button type="button" className="btn" onClick={backListDeps}>
                Назад к списку
              </button>
            )}
            {approves?.length === 0 && !selectedApprove?.id && (
              <div>Пусто, нечего согласовать</div>
            )}
            <ul className="list-group">
              {(approves ?? []).map((approve) => (
                <li
                  key={approve.id}
                  className="list-group-item autodep-clickable"
                  onClick={() => OpenApproveTS(approve.id)}
                >
                  {approve.start_date} - {approve.end_date}.{" "}
                  {approve.restaurant_name}
                </li>
              ))}
            </ul>
          </div>
          {tables.map((table) => table)}
          {approvalTable}
        </div>
      ) : (
        <div className="row">
          {accessLevel <= 12 &&
            (showLoadReceiptsBtn || (doneTemplateShifts?.length ?? 0) > 0) &&
            toolbar}
          {tables.map((table) => table)}
          {approvalTable}
        </div>
      )}

      {saveDraftFab}

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Добавление ночника
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Закрыть"
              ></button>
            </div>
            <div className="modal-body">
              <p className="text-muted mb-3">Дата: {selectedDate}</p>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Начало смены</label>
                  <input
                    type="number"
                    className="form-control"
                    min={0}
                    max={23}
                    value={startNewTS}
                    onChange={(e) => setStartNewTS(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Конец смены</label>
                  <input
                    type="number"
                    className="form-control"
                    min={0}
                    max={23}
                    value={endNewTS}
                    onChange={(e) => setEndNewTS(e.target.value)}
                  />
                </div>
                <div className="col-12">
                  <label className="form-label">Кол-во часов</label>
                  <input
                    type="number"
                    className="form-control"
                    disabled
                    value={TSHours}
                  />
                </div>
              </div>
              <div className="autodep-hour-presets mt-3">
                {[
                  [22, 6],
                  [23, 7],
                  [0, 8],
                ].map(([start, end]) => (
                  <button
                    key={`${start}-${end}`}
                    type="button"
                    className="btn btn-sm btn-outline-secondary me-2 mb-2"
                    onClick={() => {
                      setStartNewTS(start);
                      setEndNewTS(end);
                    }}
                  >
                    {start}:00 — {end}:00
                  </button>
                ))}
              </div>
            </div>
            <div className="text-center">{modalMessageCreate}</div>
            <div className="modal-footer">
              <button type="button" className="btn" data-bs-dismiss="modal">
                Закрыть
              </button>
              <button type="button" className="btn btn-primary" onClick={addTS}>
                Создать смену
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="editShiftModal"
        ref={editShiftModalRef}
        tabIndex="-1"
        aria-labelledby="editShiftModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="editShiftModalLabel">
                Редактирование смены
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Закрыть"
              ></button>
            </div>
            {editModalShift?.id && (
              <>
                <div className="modal-body">
                  <div className="alert alert-light border mb-3">
                    <div className="fw-semibold">{selectedShiftLabel}</div>
                  </div>

                  <div className="fw-semibold mb-2">Длина смены</div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Начало (добавить часы слева)</label>
                      <div className="input-group">
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => adjustSelectedShift("start", -1)}
                        >
                          −
                        </button>
                        <input
                          type="number"
                          className="form-control text-center"
                          value={startPlusEditTS}
                          onChange={(e) => handleStartPlusInputChange(e.target.value)}
                          onBlur={() => {
                            if (
                              startPlusEditTS === "" ||
                              Number.isNaN(parseFloat(startPlusEditTS))
                            ) {
                              setStartPlusEditTS(selectedTS.plus_before || 0);
                            }
                          }}
                          min={0}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-success"
                          onClick={() => adjustSelectedShift("start", 1)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Конец (добавить часы справа)</label>
                      <div className="input-group">
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          onClick={() => adjustSelectedShift("end", -1)}
                        >
                          −
                        </button>
                        <input
                          type="number"
                          className="form-control text-center"
                          value={endPlusEditTS}
                          onChange={(e) => handleEndPlusInputChange(e.target.value)}
                          onBlur={() => {
                            if (
                              endPlusEditTS === "" ||
                              Number.isNaN(parseFloat(endPlusEditTS))
                            ) {
                              setEndPlusEditTS(selectedTS.plus_after || 0);
                            }
                          }}
                          min={0}
                        />
                        <button
                          type="button"
                          className="btn btn-outline-success"
                          onClick={() => adjustSelectedShift("end", 1)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  <hr className="my-4" />

                  <div className="fw-semibold mb-2">Деление смены</div>
                  <label htmlFor="divideShiftRange" className="form-label">
                    Точка разделения (часы от начала)
                  </label>
                  <input
                    onChange={(e) => dividingTS(parseInt(e.target.value, 10))}
                    type="range"
                    className="form-range"
                    min="0"
                    max={Math.max(0, editModalShift.hours - 1)}
                    step={1}
                    value={divideSelectedTS}
                    id="divideShiftRange"
                  />
                  <div className="d-flex justify-content-between small text-muted">
                    <span>
                      Первая: {firstDivededTS.start} — {firstDivededTS.end}
                    </span>
                    <span>
                      Вторая: {secondDivededTS.start} — {secondDivededTS.end}
                    </span>
                  </div>
                </div>
                <div className="text-center px-3">{modalMessageEdit}</div>
                <div className="modal-footer">
                  <button type="button" className="btn" data-bs-dismiss="modal">
                    Закрыть
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={divideTS}
                  >
                    Разделить
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="approvalModal"
        tabIndex="-1"
        aria-labelledby="approvalModelLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h1 className="modal-title fs-5" id="approvalModelLabel">
                Согласование
              </h1>
            </div>
            <div className="modal-body">
              <div className="select text-center">
                Этап согласования
                <select
                  className="form-select"
                  aria-label="Default select example"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="1">Не согласовано</option>
                  <option value="2">На доработке</option>
                  <option value="3">Согласовано</option>
                </select>
              </div>
              <div className="coment text-center mt-3">
                Комментарий
                <textarea
                  className="form-control"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                ></textarea>
              </div>
            </div>
            <div className="approve-message text-center">{approveMessage}</div>
            <div className="modal-footer justify-content-center">
              {disabledApproveBtn ? (
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Загрузка...</span>
                </div>
              ) : (
                <button
                  type="button"
                  className="btn"
                  onClick={PostApprove}
                  disabled={disabledApproveBtn}
                >
                  Сохранить
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutoDep;

const AUTO_DEP_STYLES = `
.autodep-root .autodep-toolbar,
.autodep-root .autodep-editor {
  border: 1px solid #e5e7eb;
}
.autodep-root .autodep-hint {
  color: #6b7280;
  font-size: 0.9rem;
}
.autodep-root.autodep-has-save-fab {
  padding-bottom: 5.5rem;
}
.autodep-root .autodep-save-fab {
  position: fixed;
  bottom: 1.25rem;
  right: 1.25rem;
  z-index: 1030;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
}
.autodep-root .autodep-save-fab-message {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  padding: 0.35rem 0.6rem;
  font-size: 0.85rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.autodep-root .autodep-clickable {
  cursor: pointer;
}
.autodep-root .autodep-day-table td {
  padding: 0;
  height: 34px;
  min-width: 28px;
  position: relative;
}
.autodep-root .autodep-hour-col {
  min-width: 34px;
  font-size: 0.75rem;
}
.autodep-root .autodep-shift-row {
  cursor: pointer;
}
.autodep-root .autodep-shift-cell {
  cursor: pointer;
  transition: filter 0.15s ease;
}
.autodep-root .autodep-shift-cell:hover {
  filter: brightness(1.08);
}
.autodep-root .autodep-shift-cell.autodep-selected,
.autodep-root .autodep-row-selected .autodep-shift-cell {
  outline: 2px solid #0d6efd;
  outline-offset: -2px;
  z-index: 1;
}
.autodep-root .autodep-plus-cell {
  background: #7b4d9e !important;
}
.autodep-root .autodep-handle {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 10px;
  cursor: ew-resize;
  z-index: 3;
}
.autodep-root .autodep-handle-start {
  left: -4px;
}
.autodep-root .autodep-handle-end {
  right: -4px;
}
.autodep-root .autodep-handle::after {
  content: "";
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 3px;
  width: 3px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.9);
}
.autodep-root.autodep-dragging,
.autodep-root.autodep-dragging * {
  cursor: ew-resize !important;
  user-select: none;
}
.autodep-root .table-gragic > p {
  font-weight: 600;
  margin-top: 1rem;
}
`;

function pushAutoDepShiftRow(
  templateShift,
  startGroup,
  offset,
  groupName,
  before,
  plusBefore,
  hours,
  plusAfter,
  after,
  showStart,
  showEnd,
  onSelectShift,
  onDragStart,
  selectedShift,
) {
  const bodyColor = templateShift.manual ? "#990099" : "#c0392b";
  const isSelected = isSameShift(selectedShift, templateShift);
  const openShiftEditor = () => onSelectShift(templateShift);

  const renderCell = (key, style, className, children, handlers = {}) => (
    <td key={key} style={style} className={className} {...handlers}>
      {children}
    </td>
  );

  const stopHandleClick = {
    onClick: (e) => e.stopPropagation(),
  };

  const cells = [];
  for (let i = 0; i < before; i += 1) {
    cells.push(renderCell(`b${i}`, {}, "", null));
  }

  for (let i = 0; i < plusBefore; i += 1) {
    const isFirst = i === 0;
    cells.push(
      renderCell(
        `pb${i}`,
        { background: "#7b4d9e" },
        `autodep-plus-cell autodep-shift-cell${isFirst ? " autodep-plus-start" : ""}${isSelected ? " autodep-selected" : ""}`,
        isFirst ? (
          <span
            className="autodep-handle autodep-handle-start"
            onMouseDown={(e) => onDragStart(e, templateShift, "start")}
            {...stopHandleClick}
            title="Потяните, чтобы изменить начало"
          />
        ) : null,
      ),
    );
  }

  for (let i = 0; i < hours; i += 1) {
    const isFirstMain = plusBefore === 0 && i === 0;
    const isLastMain = plusAfter === 0 && i === hours - 1;
    cells.push(
      renderCell(
        `h${i}`,
        { background: bodyColor },
        `autodep-shift-cell${isSelected ? " autodep-selected" : ""}`,
        <>
          {isFirstMain && (
            <span
              className="autodep-handle autodep-handle-start"
              onMouseDown={(e) => onDragStart(e, templateShift, "start")}
              {...stopHandleClick}
              title="Потяните, чтобы изменить начало"
            />
          )}
          {isLastMain && (
            <span
              className="autodep-handle autodep-handle-end"
              onMouseDown={(e) => onDragStart(e, templateShift, "end")}
              {...stopHandleClick}
              title="Потяните, чтобы изменить конец"
            />
          )}
        </>,
      ),
    );
  }

  for (let i = 0; i < plusAfter; i += 1) {
    const isLast = i === plusAfter - 1;
    cells.push(
      renderCell(
        `pa${i}`,
        { background: "#7b4d9e" },
        `autodep-plus-cell autodep-shift-cell${isLast ? " autodep-plus-end" : ""}${isSelected ? " autodep-selected" : ""}`,
        isLast ? (
          <span
            className="autodep-handle autodep-handle-end"
            onMouseDown={(e) => onDragStart(e, templateShift, "end")}
            {...stopHandleClick}
            title="Потяните, чтобы изменить конец"
          />
        ) : null,
      ),
    );
  }

  for (let i = 0; i < after; i += 1) {
    cells.push(renderCell(`a${i}`, {}, "", null));
  }

  return (
    <tr
      key={`ts_${getShiftKey(templateShift)}_${showStart}_${showEnd}`}
      className={`autodep-shift-row${isSelected ? " autodep-row-selected" : ""}`}
      onClick={openShiftEditor}
    >
      {startGroup && (
        <td rowSpan={offset} className="align-middle fw-semibold">
          {groupName}
        </td>
      )}
      <td className="align-middle">{templateShift.station_name}</td>
      <td className="text-center align-middle text-muted">Не выбрано</td>
      <td className="text-center align-middle">
        {showStart} — {showEnd}
      </td>
      {cells}
    </tr>
  );
}

function calcAutoDepCells(
  ts,
  date,
  startGroup,
  group,
  groupName,
  onSelectShift,
  onDragStart,
  selectedShift,
) {
  const tsDate = new Date(ts.date);
  const previousDay = new Date(date);
  previousDay.setDate(previousDay.getDate() - 1);

  let before = 0;
  let after = 0;
  let hours = 0;
  let plusBefore = ts.plus_before || 0;
  let plusAfter = ts.plus_after || 0;
  const showStart = ts.start - plusBefore;
  const showEnd =
    ts.end + plusAfter < 24 ? ts.end + plusAfter : ts.end + plusAfter - 24;

  if (ts.date === date) {
    if (ts.end > ts.start) {
      before = ts.start;
      after = 24 - ts.start - ts.hours;
      hours = ts.hours;
      if (plusAfter && ts.end + plusAfter < 24) {
        after -= plusAfter;
      } else if (plusAfter !== 0) {
        plusAfter -= plusAfter - after;
        after = 0;
      }
      if (plusBefore && ts.start - plusBefore > 0) {
        before -= plusBefore;
      } else if (plusBefore) {
        plusBefore = before;
        before = 0;
      }
    } else if (ts.start > ts.end) {
      before = ts.start - plusBefore;
      after = 0;
      plusAfter = 0;
      hours = 24 - ts.start;
    }
    return pushAutoDepShiftRow(
      ts,
      startGroup,
      group.length,
      groupName,
      before,
      plusBefore,
      hours,
      plusAfter,
      after,
      showStart,
      showEnd,
      onSelectShift,
      onDragStart,
      selectedShift,
    );
  }

  if (
    tsDate.getTime() === previousDay.getTime() &&
    (ts.start > ts.end ||
      (ts.start - plusBefore > ts.end + plusAfter - 24 &&
        ts.end + plusAfter - 24 > 0))
  ) {
    before = 0;
    after = 24 - ts.end;
    hours = ts.end;

    if (plusBefore) {
      plusBefore = 0;
    }

    if (ts.end + plusAfter > 24) {
      before = 0;
      plusBefore = 0;
      hours = 0;
      plusAfter = plusAfter - after;
      after = 24 - plusAfter;
    } else if (plusAfter) {
      after -= plusAfter;
    }

    return pushAutoDepShiftRow(
      ts,
      startGroup,
      group.length,
      groupName,
      before,
      plusBefore,
      hours,
      plusAfter,
      after,
      showStart,
      showEnd,
      onSelectShift,
      onDragStart,
      selectedShift,
    );
  }

  return null;
}

function renderAutoDepGrafic(
  data,
  startDate,
  endDate,
  receipts,
  setDate,
  onSelectShift,
  onDragStart,
  selectedShift,
) {
  const templateShifts = data.ts;
  const tables = [];

  const start = new Date(startDate);
  const end = new Date(endDate);
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const date = d.toISOString().split("T")[0];
    const body = [];
    const demoShifts = [];

    for (let ts of templateShifts) {
      const tsDate = new Date(ts.date);
      const previousDay = new Date(date);
      previousDay.setDate(previousDay.getDate() - 1);
      const plus_before = ts.plus_before || 0;
      const plus_after = ts.plus_after || 0;
      if (ts.date == date) {
        demoShifts.push(ts);
      }
      if (
        tsDate.getTime() === previousDay.getTime() &&
        (ts.start > ts.end ||
          (ts.start - plus_before > ts.end + plus_after - 24 &&
            plus_after &&
            ts.end + plus_after - 24 > 0))
      ) {
        if (ts.end != 0) {
          demoShifts.push(ts);
        }
      }
    }

    const ord_ts_date = demoShifts.sort((a, b) =>
      a.group_station_name.localeCompare(b.group_station_name),
    );
    const grouped = ord_ts_date.reduce((groups, ts) => {
      const key = ts.group_station_name;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(ts);
      return groups;
    }, {});

    for (let groupName in grouped) {
      grouped[groupName].sort((a, b) => a.start - b.start);
    }

    for (let groupName in grouped) {
      const group = grouped[groupName];
      let startGroup = true;
      for (let ts of group) {
        const row = calcAutoDepCells(
          ts,
          date,
          startGroup,
          group,
          groupName,
          onSelectShift,
          onDragStart,
          selectedShift,
        );
        if (row) {
          body.push(row);
        }
        startGroup = false;
      }
    }

    const dt = new Date(date);
    tables.push(
      <div className="table-gragic col-12" key={date}>
        <p className="text-center">
          Дата: {date}. День недели: {getRussianWeekday(date)}.
        </p>
        <div className="table-responsive">
          <table className="table table-bordered text-center autodep-day-table">
            <thead>
              <tr>
                <th scope="col">Группа</th>
                <th scope="col">Позиция</th>
                <th scope="col">Сотрудник</th>
                <th scope="col">С — По</th>
                {Array.from({ length: 24 }, (_, i) => {
                  dt.setHours(i);
                  return (
                    <th key={i} className="text-center autodep-hour-col" scope="col">
                      {i}
                      <div className="text-muted" style={{ fontSize: "0.7rem" }}>
                        {receipts[dt.getTime()]?.receipts || 0}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {body}
              <tr>
                <td colSpan={4}>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={() => setDate(date)}
                  >
                    + Добавить ночника
                  </button>
                </td>
                <td colSpan={24}></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>,
    );
  }
  return tables;
}

function getRussianWeekday(dateString) {
  const date = new Date(dateString);
  const days = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ];
  return days[date.getDay()];
}

function getMonthLabel(start, end) {
  const startDate = new Date(`${start}T00:00:00`);
  const endDate = new Date(`${end}T00:00:00`);
  const months = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ];
  if (
    startDate.getMonth() === endDate.getMonth() &&
    startDate.getFullYear() === endDate.getFullYear()
  ) {
    return `${startDate.getDate()}–${endDate.getDate()} ${months[startDate.getMonth()]} ${startDate.getFullYear()}`;
  }
  return `${start} — ${end}`;
}

function formatHourRange(ts) {
  const start = ts.start - (ts.plus_before || 0);
  const endRaw = ts.end + (ts.plus_after || 0);
  const end = endRaw < 24 ? endRaw : endRaw - 24;
  return `${start}:00 — ${end}:00`;
}

const ILDeploiment = [
  { min_receipts: 1, name: "Кассир 1", group_station_name: "Касса" },
  { min_receipts: 1, name: "Панировщик 1", group_station_name: "Панировка" },
  { min_receipts: 1, name: "Кликун", group_station_name: "Кухня" },
  { min_receipts: 1, name: "Зал", group_station_name: "Зал" },
  { min_receipts: 16, name: "Пакер 1", group_station_name: "Касса" },
  { min_receipts: 25, name: "Сандвичи 1", group_station_name: "Кухня" },
  { min_receipts: 36, name: "Пакер 2", group_station_name: "Касса" },
  { min_receipts: 46, name: "Презентор 1", group_station_name: "Касса" },
  { min_receipts: 46, name: "Панировщик 2", group_station_name: "Панировка" },
  { min_receipts: 56, name: "Сандвичи 2", group_station_name: "Кухня" },
  { min_receipts: 56, name: "Напитки и Десерты", group_station_name: "Касса" },
  { min_receipts: 86, name: "Жаровщик", group_station_name: "Панировка" },
  { min_receipts: 86, name: "Картофель Фри", group_station_name: "Кухня" },
  { min_receipts: 86, name: "Пакер 3", group_station_name: "Касса" },
  { min_receipts: 126, name: "Кассир 2", group_station_name: "Касса" },
  { min_receipts: 136, name: "Сбор доставки", group_station_name: "Касса" },
  { min_receipts: 146, name: "Упаковщик", group_station_name: "Касса" },
  { min_receipts: 156, name: "Презентор 2", group_station_name: "Касса" },
  { min_receipts: 176, name: "Кассир 3", group_station_name: "Касса" },
  { min_receipts: 186, name: "Пакер 4", group_station_name: "Касса" },
  { min_receipts: 236, name: "Пакер 5", group_station_name: "Касса" },
];

const FCDeploiment = [
  { min_receipts: 1, name: "Кассир 1", group_station_name: "Касса" },
  { min_receipts: 1, name: "Панировщик 1", group_station_name: "Панировка" },
  { min_receipts: 1, name: "Кликун", group_station_name: "Кухня" },
  { min_receipts: 6, name: "Пакер 1", group_station_name: "Касса" },
  { min_receipts: 26, name: "Сандвичи 1", group_station_name: "Кухня" },
  { min_receipts: 36, name: "Пакер 2", group_station_name: "Касса" },
  { min_receipts: 46, name: "Презентор 1", group_station_name: "Касса" },
  { min_receipts: 46, name: "Панировщик 2", group_station_name: "Панировка" },
  { min_receipts: 46, name: "Напитки и Десерты", group_station_name: "Касса" },
  { min_receipts: 66, name: "Сандвичи 2", group_station_name: "Кухня" },
  { min_receipts: 86, name: "Жаровщик", group_station_name: "Панировка" },
  { min_receipts: 86, name: "Картофель Фри", group_station_name: "Кухня" },
  { min_receipts: 86, name: "Пакер 3", group_station_name: "Касса" },
  { min_receipts: 126, name: "Кассир 2", group_station_name: "Касса" },
  { min_receipts: 136, name: "Сбор доставки", group_station_name: "Касса" },
  { min_receipts: 146, name: "Упаковщик", group_station_name: "Касса" },
  { min_receipts: 156, name: "Презентор 2", group_station_name: "Касса" },
  { min_receipts: 176, name: "Кассир 3", group_station_name: "Касса" },
  { min_receipts: 186, name: "Пакер 4", group_station_name: "Касса" },
  { min_receipts: 236, name: "Пакер 5", group_station_name: "Касса" },
];

const DTDeploiment = [
  { min_receipts: 5, name: "Кассир 1", group_station_name: "Касса" },
  { min_receipts: 5, name: "Панировщик 1", group_station_name: "Панировка" },
  { min_receipts: 5, name: "Кликун", group_station_name: "Кухня" },
  { min_receipts: 5, name: "DT Оплата", group_station_name: "Касса" },
  { min_receipts: 5, name: "Зал", group_station_name: "Зал" },
  { min_receipts: 16, name: "Пакер 1", group_station_name: "Касса" },
  { min_receipts: 26, name: "Сандвичи 1", group_station_name: "Кухня" },
  { min_receipts: 36, name: "DT Сбор", group_station_name: "Касса" },
  { min_receipts: 46, name: "Панировщик 2", group_station_name: "Панировка" },
  { min_receipts: 56, name: "Сандвичи 2", group_station_name: "Кухня" },
  { min_receipts: 56, name: "Презентор 1", group_station_name: "Касса" },
  { min_receipts: 86, name: "Жаровщик", group_station_name: "Панировка" },
  { min_receipts: 86, name: "Картофель Фри", group_station_name: "Кухня" },
  { min_receipts: 86, name: "DT Прием", group_station_name: "Касса" },
  { min_receipts: 86, name: "DT Выдача", group_station_name: "Касса" },
  { min_receipts: 96, name: "Пакер 2", group_station_name: "Касса" },
  { min_receipts: 126, name: "Кассир 2", group_station_name: "Касса" },
  { min_receipts: 156, name: "DT Проверка", group_station_name: "Касса" },
  { min_receipts: 227, name: "Презентор 2", group_station_name: "Касса" },
];

const selectDeploiment = {
  IL: ILDeploiment,
  FC: FCDeploiment,
  DT: DTDeploiment,
};

const generateHours = (startDate, endDate) => {
  const start = new Date(`${startDate}T00:00:00`);
  const end = new Date(endDate);
  end.setDate(end.getDate() + 1);
  end.setHours(0, 0, 0, 0);

  const hours = [];
  const current = new Date(start);

  while (current <= end) {
    hours.push(new Date(current));
    current.setHours(current.getHours() + 1);
  }

  return hours;
};

function hoursInDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function DeltaDate(dateStr, days) {
  const date = new Date(dateStr);
  date.setDate(date.getDate() + days);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getSumHoursBetween(start, end) {
  if (end == 0) {
    end = 24;
  }
  if (end > start) {
    return end - start;
  }
  return 24 - start + end;
}
